import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorWarehouseDeliveryItemsAvailability = () => {
  const deliveryItemsAvailability = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }

    ApiService.jsonRequest('/warehouse/delivery-items/availability', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { deliveryItemsAvailability }
}

export default InteractorWarehouseDeliveryItemsAvailability
